// extracted by mini-css-extract-plugin
export default {"createLoadFrame":"FreightLoad_createLoadFrame__kRrnE","createLoadFrameContent":"FreightLoad_createLoadFrameContent__d+7Mx","loadFrameButtons":"FreightLoad_loadFrameButtons__VihwY"};